
//格式化价格
export function getPriceStr(value) {
  if (!value && value != 0) {
    return ''
  }

  return '¥' + value.toFixed(2)
}
export function isMiniWechat() {
  let state = false
  wx.miniProgram.getEnv(function(res) {
    if (res.miniprogram) {
      state = true
    } else {
      state = false
    }
  })
  return state
}

function getPrices(goodTo) {
  var price = []
  if (goodTo.goodStockList && goodTo.goodStockList.length) {
    for (var i = 0; i < goodTo.goodStockList.length; i++) {
      price.push(goodTo.goodStockList[i].sellPrice)
    }
  }
  return price
}
function sortNum(a, b) {
  return a - b
}

export function getShareDataWithDetail(details) {
  let obj = {}
  let detail = Object.assign({}, details)
  if (detail) {
    let goodTo = detail.goodTo
    obj = detail
    for (let key in obj) {
      if (typeof obj[key] === 'object') {
        delete obj[key]
      }
    }

    if (goodTo && goodTo.id) {
      for (let key in goodTo) {
        if (typeof goodTo[key] === 'object') {
          delete goodTo[key]
        }
      }
      obj.goodTo = goodTo
    }
  }
  // console.log("xxxx obj = ", obj)
  return obj
}

export function getDescriptionOfDetails(detail) {
  var res = ''
  var start = 0
  if (detail.author && detail.author.length) {
    start = 1
    res += detail.author
  }
  if (detail.year && detail.year.length) {
    res += start == 1 ? ' / ' : ''
    res += detail.year
    start = 1
  }
  if (detail.size && detail.size.length) {
    res += start == 1 ? ' / ' : ''
    res += detail.size
    start = 1
  }
  if (detail.material && detail.material.length) {
    res += start == 1 ? ' / ' : ''
    res += detail.material
    start = 1
  }
  if (detail.padescription && detail.padescription.length) {
    res += start == 1 ? ' / ' : ''
    res += detail.padescription
  }
  if (detail.process && detail.process.length) {
    res += start == 1 ? ' / ' : ''
    res += detail.process
  }
  if (res.length > 3 && res.charAt(res.length - 3) == ' / ') {
    res = res.substring(0, res.length - 3)
  }
  return res
}
export function formatLargePrice(p, mainPrice) {
  if (!mainPrice) mainPrice = '¥'
  var price = parseInt(p)
  if (price < 10000) return mainPrice + p
  var wan =
    price % 10000 == 0
      ? parseInt(price / 10000)
      : (parseFloat(price / 10000).toFixed(2) * 100) / 100
  return mainPrice + wan + '万'
}

export function formatAucPriceRangeWithCurrencyType(
  priceLow,
  priceHigh,
  currency
) {
  if (priceLow >= 0 && priceHigh >= 0) {
    if (priceLow == priceHigh) {
      return largePrice(priceHigh, currency)
    }
    return (
      largePrice(priceLow, currency) + '-' + largePrice(priceHigh, currency)
    )
  } else {
    if (priceLow) {
      return largePrice(priceLow, currency)
    } else if (priceHigh) {
      return largePrice(priceHigh, currency)
    }
  }
}
function largePrice(p, currency) {
  if (!currency) currency = ''
  var price = parseInt(p)
  if (price < 10000) return currency + p
  var wan =
    price % 10000 == 0
      ? parseInt(price / 10000)
      : (parseFloat(price / 10000).toFixed(2) * 100) / 100
  return currency + wan + '万'
}
// 获取百分比
export function getFloatNum(value) {
  return Math.floor(value * 10000) / 100
}
export function formatAuctionPrice(priceLow, priceHigh) {
  if (priceLow >= 0 && priceHigh >= 0) {
    if (priceLow == priceHigh) {
      return largePrice(priceHigh)
    }
    return largePrice(priceLow) + '-' + largePrice(priceHigh)
  } else {
    if (priceLow || priceLow == 0) {
      return largePrice(priceLow)
    } else if (priceHigh || priceHigh == 0) {
      return largePrice(priceHigh)
    }
  }
}

function ticketPriceComputed(priceLow, priceHigh) {
  if (priceLow && priceHigh) {
    if (priceLow == priceHigh) {
      return '¥ ' + priceHigh
    }
    return '¥ ' + priceLow + '-' + priceHigh
  } else {
    if (priceLow) {
      return '¥ ' + priceLow
    } else if (priceHigh) {
      return '¥ ' + priceHigh
    } else if (priceLow === priceHigh && priceLow === 0) {
      return '¥ 0'
    } else {
      return '¥ 0'
    }
  }
}
// 日期格式化 yyyy-mm-dd hh-mm-ss
export function formatDateTime(value) {
  let date = new Date(value)
  return value
    ? `${date.getFullYear()}-${leftPad(date.getMonth() + 1)}-${leftPad(
        date.getDate()
      )} ${leftPad(date.getHours())}:${leftPad(date.getMinutes())}:${leftPad(
        date.getSeconds()
      )}`
    : ''
}

// 日期格式化 yyyy-mm-dd
export function formatDate(value) {
  let date = new Date(value)
  return value
    ? `${date.getFullYear()}-${leftPad(date.getMonth() + 1)}-${leftPad(
        date.getDate()
      )}`
    : ''
}
function leftPad(n) {
  return n < 10 ? '0' + n : n
}


// 日期格式化 mm-dd hh-mm
export function shareformatDateTime(value) {
  let date = new Date(value)
    return value? `${leftPad(date.getMonth() + 1)}/${leftPad(
      date.getDate()
    )} ${leftPad(date.getHours())}:${leftPad(date.getMinutes())}`:''
}


// 日期格式化 mm-dd hh-mm
export function formatDateTimeMM(value) {
  let date = new Date(value)
    return value? `${leftPad(date.getMonth() + 1)}/${leftPad(
      date.getDate()
    )}  ${leftPad(date.getHours())}:${leftPad(date.getMinutes())}:${leftPad(
      date.getSeconds()
    )}`
  : ''
}




export function handleTree(data, id, parentId, children) {
    let config = {
      id: id || 'id',
      parentId: parentId || 'parentId',
      childrenList: children || 'children'
    };
    var childrenListMap = {};
    var nodeIds = {};
    var tree = [];
    for (let d of data) {
      let parentId = d[config.parentId];
      if (childrenListMap[parentId] == null) {
        childrenListMap[parentId] = [];
      }
      nodeIds[d[config.id]] = d;
      childrenListMap[parentId].push(d);
    }
    for (let d of data) {
      let parentId = d[config.parentId];
      if (nodeIds[parentId] == null) {
        tree.push(d);
      }
    }
    for (let t of tree) {
      adaptToChildrenList(t);
    }
    function adaptToChildrenList(o) {
      if (childrenListMap[o[config.id]] !== null) {
        o[config.childrenList] = childrenListMap[o[config.id]];
      }
      if (o[config.childrenList]) {
        for (let c of o[config.childrenList]) {
          adaptToChildrenList(c);
        }
      }
    }
    return tree;
  }


export function isNewPlate(time_str){
      if(!time_str){
        return ''
      }
      time_str ? time_str.replace(/T/g, " ").replace(/.[\d]{3}Z/, "") : ""
      var now = new Date();
      
      var date = new Date(time_str);
      
      //计算时间间隔，单位为分钟
      var inter = parseInt((now.getTime() - date.getTime())/1000/60);
      
     return inter<5 ?true:false
  }

    export function getTimeShow(time_str){
    
    if(!time_str){
      return ''
    }
    time_str ? time_str.replace(/T/g, " ").replace(/.[\d]{3}Z/, "") : ""
    var now = new Date();
    
    var date = new Date(time_str);
    
    //计算时间间隔，单位为分钟
    var inter = parseInt((now.getTime() - date.getTime())/1000/60);
    
    if(inter == 0 || inter<0){
    
    return "刚刚";
    
    }
    //多少分钟前
    
    else if(inter < 60){
    
    return inter.toString() + "分钟前";
    
    }
    
    //多少小时前
    
    else if(inter < 60*24){
    
    return parseInt(inter/60).toString() + "小时前";
    
    }
    
    //本年度内，日期不同，取日期+时间  格式如  06-13 22:11
    
    else if(now.getFullYear() == date.getFullYear()){
    
    return (date.getMonth()+1).toString() + "-" +
    
    date.getDate().toString() + " " +
    
    date.getHours() + ":" +
    
    date.getMinutes();
    
    }
    else{
    return date.getFullYear().toString() + "-" +
    
    (date.getMonth()+1).toString() + "-" +
    
    date.getDate().toString() + " " +
    
    date.getHours() + ":" +
    
    date.getMinutes();
    
    }
    }




    export function setTimeDays(time_str){
    
      if(!time_str){
        return ''
      }
      time_str ? time_str.replace(/T/g, " ").replace(/.[\d]{3}Z/, "") : ""
      var now = new Date();
      
      var date = new Date(time_str);
      
      //计算时间间隔，单位为分钟
      var inter = parseInt((now.getTime() - date.getTime())/1000/60);
      
      if(inter == 0 || inter<0){
      
      return "刚刚";
      
      }
      //多少分钟前
      
      else if(inter < 60){
      
      return inter.toString() + "分钟前";
      
      }
      
      //多少小时前
      
      else if(inter < 60*24){
      
      return parseInt(inter/60).toString() + "小时前";
      
      }
      else if(inter>60*24){
        return parseInt(inter/60/24).toString() + "天前";
      }
      
      //本年度内，日期不同，取日期+时间  格式如  06-13 22:11
      
      else if(now.getFullYear() == date.getFullYear()){
      
      return (date.getMonth()+1).toString() + "-" +
      
      date.getDate().toString() + " " +
      
      date.getHours() + ":" +
      
      date.getMinutes();
      
      }
      else{
      return date.getFullYear().toString() + "-" +
      
      (date.getMonth()+1).toString() + "-" +
      
      date.getDate().toString() + " " +
      
      date.getHours() + ":" +
      
      date.getMinutes();
      
      }
    }

    /**
 * 加密方法
 * @param data
 * @returns {string}
 */
     import CryptoJS from 'crypto-js';
export function encrypt(data,uuid) {
  const SECRET_KEY = CryptoJS.enc.Utf8.parse(uuid);
  const SECRET_IV = CryptoJS.enc.Utf8.parse('MsAQWm6qn7RmyvHo');
  if (typeof data === "object") {
    try {
      // eslint-disable-next-line no-param-reassign
      data = JSON.stringify(data);
    } catch (error) {
      console.log("encrypt error:", error);
    }
  }
  const dataHex = CryptoJS.enc.Utf8.parse(data);
  const encrypted = CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
    iv: SECRET_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.ciphertext.toString();
}
import UUID from 'uuidjs';
export function getParams(){
  let uuid = UUID.generate();
  var reg = new RegExp('-', 'g');
  uuid = uuid.replace(reg, '');
  let psd = encrypt('123456', uuid);
  let obj = {
    userName: 'lzx',
    passWord: psd,
    uuid: uuid,
  };
  return obj
}



export function getParamsLogin(user,psd){
  let uuid = UUID.generate();
  var reg = new RegExp('-', 'g');
  uuid = uuid.replace(reg, '');
  let obj = {
    userName: user,
    passWord: encrypt(psd, uuid),
    uuid: uuid,
  };
  return obj
}

//深拷贝
export function deepClone(source) { // 拷贝
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetobj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetobj[keys] = deepClone(source[keys])
    } else {
      targetobj[keys] = source[keys]
    }
  })
  return targetobj
}


//日期格式移除T
export function formatDateTimeRT(value) {
  return getFormatDate(value)
  // return getFormatDate(value ? value.replace(/T/g, " ").replace(/.[\d]{3}Z/, "") : "")
}
function getFormatDate(value) {
  let date = new Date(value)
  return value
    ? `${date.getFullYear()}-${leftPad(date.getMonth() + 1)}-${leftPad(
        date.getDate()
      )}`
    : ''
}

export function formatDatehms(datetime) {
  var regTime = datetime.replace(/\-/g, "/");
  let date=new Date(regTime)
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  return [hh, mm].map(formatNumber).join(':');
}


var formatNumber = function (n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}

export function twoFixed(value) {
  value = Math.round(parseFloat(value) * 100) / 100
  let s = value.toString().split('.')
  console.log('s :>> ', s)
  // 只有整数
  if (s.length === 1) {
    value = value.toString() + '.00'
    return value
  }
  // 有小数
  if (s.length > 1) {
    // 只有一位小数
    if (s[1].length < 2) {
      value = value.toString() + '0'
    }
    return value
  }
}


export function replaceKey(str){
  if(!str){
    return ''
  }
  let a=str.substr(0,2)+'**'
  return a
}

export function replaceKeys(str){
  if(!str){
    return ''
  }
  let a=str.substr(0,4)+'**'
  return a
}


export function replaceStr(str){
  let a=str
  if(!str){
    return ''
  }
  if(str.length>8){
    a=str.substr(0,8)+'...'
  }
  return a
}

export function viptype(type){
  switch (type) {
    case 2:
      return '月会员'
      break;
      case 3:
      return '季会员'
      break;
      case 4:
        return '半年卡会员'
        break;
        case 5:
          return '年会员'
          break;
  
    default:
      break;
  }
}

export function cardType(type){
  let t=Number(type)
  switch (t) {
      case 4:
      return '[成交贴]'
      break;
      case 2:
      return '[出售贴]'
      break;
      case 1:
        return '[求购贴]'
        break;
    default:
      return ''
      break;
  }
}



export function geturlparam(url,key){
  let p=url.split('?')[1]
  let params=new URLSearchParams(p)
  return params.get(key)
}


//判断时间是否是当天
export function isToday(str) {
  var d = new Date(str);
  var todaysDate = new Date();
  if(d.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)){
      return true;
  } else {
      return false;
  }
}

export function  IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod');
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}


//数组随机排序
export function shuffle(array) {  
  var currentIndex = array.length, temporaryValue, randomIndex;  
  // 当还有元素需要洗牌时  
  while (0 !== currentIndex) {  
  
    // 选取剩下的元素  
    randomIndex = Math.floor(Math.random() * currentIndex);  
    currentIndex -= 1;  
  
    // 并与当前元素交换  
    temporaryValue = array[currentIndex];  
    array[currentIndex] = array[randomIndex];  
    array[randomIndex] = temporaryValue;  
  }  
  
  return array;  
}




export function setFormateDateEnd(dateTime){
  let date=new Date(dateTime)
  date.setHours(23);  
  date.setMinutes(59);  
  date.setSeconds(59);  
  return date
  ? date
  : ''
}

//判断是否过期
export function isMoreThan24Hours(dateString) {  
  let  targetDate = new Date(dateString).getTime();  
  let now = new Date().getTime()
  
  const timeDifference = now - targetDate;  
  const hoursDifference = timeDifference / (60 * 60 * 1000); // 将毫秒转换为小时  
  
  if (hoursDifference > 24) {  
    return true; // 超过24小时  
  } else {  
    return false; // 未超过24小时  
  }  
} 

//判断是否在2分钟内
export function isWithinTwoMinutes(text) {
  let list=JSON.parse(window.localStorage.getItem('createPostList')) || [];
  let now = new Date().getTime();  
  let isRepeat=null;
  console.log(text)
  list.map(item=>{
    if(item.title==text && Math.abs(now - new Date(item.lastUpdateTime).getTime())<120000){
      isRepeat=item
    }
  })
  return isRepeat;  
}

//发的帖子存在本地与接口做对比  
export function setRecordPostData(data){
  let arr=[]
  let oldData=JSON.parse(window.localStorage.getItem('createPostList')) || []
  if(oldData && oldData.length>0){
    if(oldData.length==10){
      oldData.pop()
    }
    oldData.map(item=>{
      if(!isMoreThan24Hours(item.createTime)){
        arr.unshift(item)
      }
    })
  }
  arr.unshift(data)
  window.localStorage.setItem('createPostList',JSON.stringify(arr))
  console.log(arr)
}